import { MessageSquare } from 'lucide-react'
import { cn } from '@/lib/utils'

/**
 * Opent de correspondentie bij een uitbetaalregel: vierkant icoonknopje zoals de
 * rest van de rij-acties, met een accentstip zodra er reacties liggen.
 *
 * Staat er voor iedereen die mag reageren, niet alleen voor beheerders: de
 * ontvanger van de regel voert hier zijn kant van het gesprek.
 */
export function CommentToggle({
  count,
  open,
  canComment,
  onToggle,
  className,
}: {
  count: number
  open: boolean
  canComment: boolean
  onToggle: () => void
  className?: string
}) {
  if (!canComment) return null

  const label = count === 0 ? 'Nog geen reacties' : count === 1 ? '1 reactie' : `${count} reacties`

  return (
    <button
      type="button"
      className={cn('btn-ghost relative h-8 w-8 shrink-0 p-0', open || count > 0 ? 'text-ink' : 'text-ink-faint', className)}
      onClick={onToggle}
      title={label}
      aria-label={label}
      aria-expanded={open}
    >
      <MessageSquare className="h-3.5 w-3.5" />
      {count > 0 ? <span className="absolute right-1 top-1 h-1.5 w-1.5 rounded-full bg-accent-600" /> : null}
    </button>
  )
}
